export const tempLinkDownloader = (blob, name, type = "image/pdf") => {
    const file = new File([blob], name, { type })
    const objUrl = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = objUrl;
    link.setAttribute('download', name)
    link.target = "_blank";
    link.click();
  }